/**
=========================================================
* Trust Cargo - field labels
=========================================================

* A field's label sits above its box, at a size that can be read, rather
* than shrunk to 75% and squeezed onto the box's top border - where an
* Arabic label was hardest to read of all. It turns gold with the box
* while typing, and red with it when something is wrong.
*/

import colors from "assets/theme/base/colors";
import rgba from "assets/theme/functions/rgba";

import pxToRem from "assets/theme/functions/pxToRem";

const { dark, error, inputColors } = colors;

const inputLabel = {
  defaultProps: {
    shrink: true,
  },

  styleOverrides: {
    root: {
      position: "relative !important",
      transform: "none !important",
      maxWidth: "100%",
      marginBottom: pxToRem(6),
      fontSize: `${pxToRem(13)} !important`,
      fontWeight: 600,
      lineHeight: 1.3,
      color: rgba(dark.main, 0.75),
      whiteSpace: "normal",
      pointerEvents: "auto",

      "&.Mui-focused": {
        color: inputColors.borderColor.focusText,
      },
      "&.Mui-error": {
        color: error.main,
      },
    },

    asterisk: {
      color: error.main,
    },
  },
};

export default inputLabel;
